module.exports = __webpack_public_path__ + "static/media/waipinjiangshishenqingbiao.267ffdfa.png";